<template>
  <v-dialog :persistent="persistent" v-model="dialog" max-width="480px">
    <v-card>
      <v-card-title class="mx-3">
        {{ title ? title : $t("$vuetify.alert") }}
        <v-spacer></v-spacer>
      </v-card-title>
      <v-divider />
      <v-card-text class="px-4 py-8 text-center subtitle-1">
        {{ message }}
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn
          color="accent"
          outlined
          depressed
          @click="
            $emit('cancel');
            dialog = false;
          "
        >
          {{ $t("$vuetify.close") }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "BatchOperationInfoAlert",

  props: {
    value: Boolean,
    title: String,
    message: String,
    useConfirm: Boolean,
    persistent: Boolean,
    closable: Boolean,
  },

  data: () => ({
    dialog: false,
  }),

  watch: {
    value: {
      immediate: true,
      handler() {
        this.dialog = this.value;
      },
    },
    dialog: {
      handler() {
        this.$emit("input", this.dialog);
        if (!this.dialog) this.$emit("close");
      },
    },
  },
};
</script>
